<template>
  <div>
    <el-card v-for="(item, index) in value[name]" :key="index" style="margin-bottom: 10px">
      <el-button type="danger" style="float: right" icon="el-icon-delete" circle size="mini" @click="removeItem(index)"></el-button>
      <span style="margin-right: 10px">Name</span>
      <el-input v-model="item.name" placeholder="Name of tool" style="margin-top: 6px; margin-bottom: 14px"></el-input>
      <span style="margin-right: 10px">Embed URL</span>
      <el-input v-model="item.url" placeholder="URL with https protocol" style="margin-top: 6px; margin-bottom: 14px"></el-input>
      <span style="margin-right: 10px">Icon Type (Optional)</span>
      <el-tooltip content="Element UI Icon Pack https://element.eleme.io/#/en-US/component/icon">
        <i class="el-icon-info"></i>
      </el-tooltip>
      <el-input v-model="item.icon" placeholder="Icon Type" style="margin-top: 6px; margin-bottom: 14px"></el-input>
    </el-card>
    <el-button type="primary" @click="addItem" style="margin-top: 10px">Add</el-button>
  </div>
</template>

<script>
export default {
  name: "LivechatTool",
  props: ["setting", "value", "name"],
  methods: {
    removeItem(index) {
      this.value[this.name].splice(index, 1);
    },
    addItem() {
      this.value[this.name].push({
        name: "",
        url: "",
        icon: "",
      });
    },
  },
}
</script>
